import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <main className="page container" style={{ textAlign: "center", paddingTop: 80 }}>
      <div
        style={{
          fontSize: "clamp(5rem, 18vw, 10rem)",
          fontWeight: 800,
          letterSpacing: "-0.04em",
          lineHeight: 1,
          background: "var(--grad-brand)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}
      >
        404
      </div>
      <h1 style={{ marginTop: 6 }}>Page not found</h1>
      <p className="muted" style={{ maxWidth: 420, margin: "0 auto 24px" }}>
        The page you tried to open doesn't exist — or it was shuffled into the
        bottom of the library.
      </p>
      <div className="cta" style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
        <Link to="/" className="topbar-btn primary">Go home</Link>
        <Link to="/build" className="topbar-btn">Open the builder</Link>
      </div>
    </main>
  );
}
